export const apiPath = "https://topolocal-elections-back.vercel.app/";
export const fetcher = (url) => fetch(url).then((res) => res.json());
